import React from 'react'
import { Typography, Grid, Button, Tooltip, TableRow, TableCell } from '@mui/material'
import { withNamespaces, WithNamespaces } from 'react-i18next'
import { TransactionItem } from './TransactionItem'
//import { TransactionUpIcon } from '@syncfab/machine'
import { BoldTypography } from '../../../../utils/Typography/BoldTypography'
import { RightTypography } from '../../../../utils/Typography/RightTypography'
import CallReceivedIcon from '@mui/icons-material/CallReceived'
import AttachmentIcon from '@mui/icons-material/Attachment'

interface EarnedTransactionListProps extends TransactionItem, WithNamespaces {}

export const EarnedTransactionListItem = withNamespaces()(({ transaction }: EarnedTransactionListProps) => {
    return (
        // <Grid item container spacing={8} xs={12} direction="row" justify="space-between" alignContent="center">
        //     <Grid container item xs={2} direction="row" alignContent="center">
        //         <CallReceivedIcon style={{ color: 'white' }} />
        //         <RightTypography gutterBottom>
        //             Deposit
        //             {/* {t('wallet-transactions-deposit')} */}
        //         </RightTypography>
        //     </Grid>
        //     <Grid container item xs={6}>
        //         <Grid container direction="row" alignItems="center">
        //             <Grid item>
        //                 <Typography gutterBottom variant="h3">
        //                     {transaction.context}
        //                 </Typography>
        //             </Grid>
        //             <Grid item style={{ marginLeft: '12px' }}>
        //                 <Tooltip style={{ backgroundColor: 'black' }} title="View on Etherscan">
        //                     <AttachmentIcon
        //                         style={{ color: 'white' }}
        //                         onClick={() => {
        //                             window.open('https://etherscan.io/tx/' + transaction.txnHash, '_blank')
        //                         }}
        //                     />
        //                 </Tooltip>
        //             </Grid>
        //             <Typography gutterBottom>
        //                 From:{' '}
        //                 <Button variant="text" color="primary">
        //                     {transaction.particular}
        //                 </Button>
        //             </Typography>
        //         </Grid>
        //         {/* <Typography gutterBottom>
        //             From: <Button variant="text" color="primary">{transaction.particular}</Button>
        //         </Typography> */}
        //         {/* <Typography gutterBottom>{t('wallet-transactions-earned-description')}</Typography> */}
        //     </Grid>
        //     <Grid item xs={2}>
        //         <Typography gutterBottom>{new Date(transaction.createdAt).toLocaleDateString()}</Typography>
        //     </Grid>
        //     <Grid item xs={2}>
        //         <BoldTypography gutterBottom>+{transaction.value} MFG</BoldTypography>
        //     </Grid>
        // </Grid>
        <TableRow key={transaction._id}>
            <TableCell style={{ padding: '4px 24px' }}>
                <Grid container direction="row" alignContent="flex-start">
                    <CallReceivedIcon style={{ color: 'white' }} />
                    <RightTypography gutterBottom>
                        Deposit
                        {/* {t('wallet-transactions-deposit')} */}
                    </RightTypography>
                </Grid>
            </TableCell>
            <TableCell style={{ padding: '4px 24px' }}>
                <Grid container item>
                    <Grid container direction="row" alignItems="center">
                        <Grid item>
                            <Typography gutterBottom variant="h3">
                                {transaction.context}
                            </Typography>
                        </Grid>
                        <Grid item style={{ marginLeft: '12px' }}>
                            <Tooltip style={{ backgroundColor: 'black' }} title="View on Etherscan">
                                <AttachmentIcon
                                    style={{ color: 'white' }}
                                    onClick={() => {
                                        window.open('https://etherscan.io/tx/' + transaction.txnHash, '_blank')
                                    }}
                                />
                            </Tooltip>
                        </Grid>
                    </Grid>

                    <Typography gutterBottom>
                        From:{' '}
                        <Button
                            variant="text"
                            color="primary"
                            onClick={() => {
                                window.open('https://etherscan.io/address/' + transaction.particular, '_blank')
                            }}
                        >
                            {transaction.particular}
                        </Button>
                    </Typography>
                </Grid>
            </TableCell>
            <TableCell>
                <Grid item>
                    <Typography gutterBottom>{new Date(transaction.createdAt).toLocaleDateString()}</Typography>
                </Grid>
            </TableCell>
            <TableCell>
                <Grid item>
                    <BoldTypography gutterBottom>+{transaction.value} MFG</BoldTypography>
                </Grid>
            </TableCell>
            {/* <TableCell align="right">{row.calories}</TableCell>
        <TableCell align="right">{row.fat}</TableCell>
        <TableCell align="right">{row.carbs}</TableCell>
        <TableCell align="right">{row.protein}</TableCell> */}
        </TableRow>
    );
})
